module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAHCAYAAAAxrNxjAAAAAXNSR0IArs4c6QAAAJNJREFUGBljYEAD02bPSwNhNGEGRmSBGXPnWv7/y3AAJMbIzOCQkZx8HCYPVzhz5mLJfww/z/5nYJAEK2RgeM7EwG6cnh77HMRnAhGrVq1i+8fway1MEUgMxAaJgeRAfLDCN+8/T/7P8N8SJIAMQGIgOZAYI9jh//7NRFaAwWZiSmdhYvp/+T8DsyOGJJIAI9O/nwAymzVwXorPUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/v2/keyword-collapse.png
// module id = 175
// module chunks = 33